import { t } from "i18next";
import { IconLoading } from "@icons/index";
import { stripProtocol } from "@pages/aiStudio/ScriptExport/insight";
import type { ReferenceVideoLinkStatus } from "@pages/videoRemake/useReferenceVideoLink";

export interface ReferenceVideoLinkPanelProps {
  value: string;
  onChange: (value: string) => void;
  status: ReferenceVideoLinkStatus;
  errorMessage: string | null;
  onDebouncedParse: (value: string) => void;
  onParseNow: (value: string) => void;
}

export const ReferenceVideoLinkPanel = ({
  value,
  onChange,
  status,
  errorMessage,
  onDebouncedParse,
  onParseNow,
}: ReferenceVideoLinkPanelProps) => {
  const isLoading = status === "loading";

  return (
    <div className="flex flex-col items-center justify-center gap-[24px] px-[16px] pt-[40px] pb-[48px]">
      <div className="flex items-center gap-[8px] h-[56px] px-[12px] w-[672px] rounded-[8px] border border-kds-border-subtle bg-kds-bg-element">
        <span className="text-[16px] leading-[24px] font-semibold text-kds-fg whitespace-nowrap">https://</span>
        <div className="w-px h-[48px] bg-kds-border-solid shrink-0" />
        <input
          type="text"
          value={value}
          disabled={isLoading}
          onChange={(e) => {
            const stripped = stripProtocol(e.target.value);
            onChange(stripped);
            if (stripped.trim()) {
              onDebouncedParse(stripped);
            }
          }}
          onKeyDown={(e) => {
            if (isLoading) return;
            if ((e.code === "Enter" || e.code === "NumpadEnter") && e.keyCode !== 229) {
              onParseNow(value);
            }
          }}
          placeholder={t("Paste a TikTok, Kalodata, or YouTube Shorts video link.")}
          className="flex-1 min-w-0 bg-transparent border-none outline-none text-[14px] leading-[20px] text-kds-fg placeholder:text-kds-fg-subtle disabled:opacity-60"
        />
        {isLoading && <IconLoading className="size-5 shrink-0 animate-spin text-kds-fg-soft" />}
      </div>

      {errorMessage && <p className="w-[672px] text-[12px] leading-[16px] text-kds-danger">* {errorMessage}</p>}
    </div>
  );
};
